export const preparePreviewData = ({ lotState, lotImages, tagIds, editorState, subcategoryId, ...formData }) => ({
  ...formData,
  fixedPrice: Number(formData.fixedPrice),
  lotState: lotState === 0 ? 'New' : 'Used',
  images: lotImages.map(({ thumbUrl, uid }, index) => ({ fileName: thumbUrl, id: index, lotId: uid })),
  tags: tagIds,
  categoryId: subcategoryId,
  description: editorState?.currentTarget?.value,
});

export const prepareSingleLotData = (data, singleLot) => ({
  id: data.id,
  title: data.title,
  description: data.description ?? '', 
  currency: data.currencyOrigin ?? data.currency,
  categoryId: data.categoryId ?? '',
  lotState: data.lotState,
  lotType: data.lotType,
  productType: data.productType,
  tagIds: data.tags,
  locationId: data.location.id,
  fixedPrice: (data.fixedPriceOrigin ?? data.fixedPrice) ?? '',
  lotImagesToAdd: data.images,
  mainImageIndex: data.mainImageIndex,
  lotLocation: { ...singleLot.lotLocation },
  userId: data.userId,
});
